import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhankai",
  "use": "icon-zhankai-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhankai\">\r\n<path d=\"M1 1L5 5L9 1\" stroke=\"#B5B5BE\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol